import { h } from "preact";
import {
  FormField, FormFieldDate,
  FormFieldSelect,
  FormFieldTextArea,
  InputField,
  Select
} from '../../../_common/forms/components/components'
import Modal from '../../../_common/components/Modal/index'
import {useEffect, useMemo} from 'preact/hooks'
import { ButtonPrimary } from '../../../_common/components/buttons/buttons'
import { t } from '../../../_i18n'
import {useState} from "react";
import TimePickerField from "../TimePicker/timePickerField";
import {validateForm} from "../TimePicker/timePickerValidation";

const availabilty_options = [
  {key: 'all_day', name: 'Todo el día'},
  {key: 'morning', name: 'Mañanas'},
  {key: 'evenoon', name: 'Tardes'},
  {key: 'rotative', name: 'Rotativo'}
]

export default function ModalSchedule ({ visible, onClose, input, onBlur }) {

  const oldValues = useMemo(() => ({
    availability: input.value.availability,
    from_time: input.value.from_time,
    to_time: input.value.to_time,
    text: input.value.text,
  }), []);

  const [selectedAvailability, setSelectedAvailability] = useState('');
  const [isFormValid, setIsFormValid] = useState(false);
  const [rotativeText, setRotativeText] = useState('');
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');

  useEffect(() => {
    if (visible) {
      setSelectedAvailability(input.value.availability);
      setRotativeText(input.value.text);
      setStartTime(input.value.from_time);
      setEndTime(input.value.to_time);
    }
  }, [visible, input.value]);

  useEffect(() => {
    setIsFormValid(validateForm(selectedAvailability, rotativeText, startTime, endTime));
  }, [selectedAvailability, rotativeText, startTime, endTime]);

  const handleSelectChange = (event) => {
    const value = event.target.value;
    setSelectedAvailability(value);
    setRotativeText('');
    setStartTime('');
    setEndTime('');
  };

  const handleClose = () => {
    input.onChange(oldValues);
    onClose();
  }

  const saveData = () => {
    const newValues = {
      ...input.value,
      availability: selectedAvailability,
      from_time: startTime,
      to_time: endTime,
      text: rotativeText,
    };

    input.onChange(newValues);
    onBlur();
    onClose();
  };

  return (
      <Modal visible={visible} closeModal={handleClose}>
        <div className='fct-modal'>
          <div className='fct-modal-header'>
            <i className="fal fa-times" onClick={handleClose} />
          </div>
          <div className='fct-modal-body__title font-bold m-bottom'>{t('Disponibilidad horaria')}</div>
          <div className='fct-modal-body'>
            <div className='input-schedule-body'>
              <Select
                  className="width-fit-content form-control"
                  name="meta.availability"
                  label={<span dangerouslySetInnerHTML={{__html: t('availability_label')}}/>}
                  specificError={t('Este campo es obligatorio')}
                  value={selectedAvailability}
                  required
                  options={availabilty_options}
                  onChange={handleSelectChange}
              />

              { selectedAvailability !== 'rotative' && (
                  <TimePickerField
                      selectedAvailability={selectedAvailability}
                      setStartTime={setStartTime}
                      setEndTime={setEndTime}
                      startTime={startTime}
                      endTime={endTime}
                  />
              )}

              { selectedAvailability === 'rotative' && (
                  <FormFieldTextArea
                      className="m-top"
                      name='meta.text'
                      defaultValue={input.value.text}
                      showOptional={false}
                      required
                      specificError={t('Por favor, antes de enviar tu comentario, asegúrate de haber escrito algún texto.')}
                      label={t('Describe cómo es tu disponibilidad rotativa')}
                      value={rotativeText}
                      onChange={(e) => setRotativeText(e)}
                  />
              )}
            </div>
            <div className='m-top-x2 d-flex flex-right'>
              <ButtonPrimary type='button' disabled={!isFormValid} onClick={saveData} >{t('Guardar')}</ButtonPrimary>
            </div>
          </div>
        </div>
      </Modal>
  )
}
